import { api } from './api';

export interface CountyOwnerTeam {
    team_id: number;
    team_name: string;
    short_name: string | null;
    primary_color: string | null;
    map_color: string | null;
    logo_url: string | null;
    espn_team_id: number | null;
}

export interface CountyLeagueOwner {
    league_id: string;
    league_name: string;
    season: number | null;
    team: CountyOwnerTeam;
}

export interface CountyInfo {
    county_fips: string;
    county_name: string;
    state_name: string;
    population: number | null;
    state_slug: string;
    county_slug: string;
}

export interface CountyHeadline {
    league_id: string;
    holder: string | null;
    taken_from: string | null;
    taken_on: string | null;
    sentence: string;
}

export interface CountyOwners {
    county: CountyInfo;
    owners: CountyLeagueOwner[];
    headline: CountyHeadline | null;
}

export const countyService = {
    async listCounties(): Promise<CountyInfo[]> {
        const res = await api.get<{ success: boolean; counties: CountyInfo[]; error?: string }>(
            '/locate/counties'
        );
        if (!res.success || !res.data?.counties) throw new Error(res.error || 'Failed to list counties');
        return res.data.counties;
    },

    async getOwners(stateSlug: string, countySlug: string): Promise<CountyOwners> {
        const res = await api.get<{
            success: boolean;
            county: CountyInfo;
            owners: CountyLeagueOwner[];
            headline?: CountyHeadline | null;
            error?: string;
        }>(
            `/locate/county-owners?state=${encodeURIComponent(stateSlug)}&county=${encodeURIComponent(countySlug)}`
        );
        if (!res.success || !res.data?.county) throw new Error(res.error || 'County not found');
        return {
            county: res.data.county,
            owners: res.data.owners || [],
            headline: res.data.headline || null,
        };
    },
};
